import { setLocale } from 'yup';
import { suggestive } from 'yup-locale-ja';

// yup-locale-ja で定義されていないものがあるので追加
// (PR 送るなら yup-locale-ja ではなく yup-locales に送ったほうがいいかも)
const ja = {
  ...suggestive,
  array: {
    ...suggestive.array,
    length: ({ label, length }) =>
      (label ? label + 'は' : '') + `${length} つ選択してください`,
  },
};

// English locale definition
const en = {
  mixed: {
    required: ({ label }) =>
      label ? `${label} is required` : 'This field is required',
  },
  string: {
    empty: ({ label }) =>
      label ? `${label} cannot be empty` : 'This field cannot be empty',
  },
  number: {
    positive: ({ label }) =>
      label ? `${label} must be positive` : 'This field must be positive',
    max: ({ max }) => `Must be less than or equal to ${max}`,
  },
  array: {
    length: ({ label, length }) =>
      (label ? `${label} must` : 'Must') +
      ` have exactly ${length} item${length !== 1 ? 's' : ''}`,
  },
};

const locales = { ja, en };

export default (locale = I18n.locale) => {
  if (locales[locale]) {
    setLocale(locales[locale]);
  }
};
